/**
<div class="tpt-diff_time">
    <tpt-range-time data-from-date="06/25/2024" data-from-time="00:00:00" data-end-date="06/25/2024" data-end-time="23:59:59" data-time-refresh="60000"></tpt-range-time>

    <div class="tpt-diff_time-label">
        <span>0%</span>
        <span>100%</span>
    </div>
</div> 
*/

if (!customElements.get("tpt-range-time")) {
	customElements.define(
		"tpt-range-time",
		class TptComingSoon extends HTMLElement {
			constructor() {
				super();

				this.currentDateTime = new Date();
				this.fromDate = this.getAttribute("data-from-date");
				this.fromTime = this.getAttribute("data-from-time");
				this.endDate = this.getAttribute("data-end-date");
				this.endTime = this.getAttribute("data-end-time");
				this.fromDateTime = this.fromDate + " " + this.fromTime;
				this.endDateTime = this.endDate + " " + this.endTime;
				this.timeRefresh = parseInt(this.getAttribute("data-time-refresh"));

				this.getPercentRange(new Date(this.fromDateTime), new Date(this.endDateTime), new Date());

				this.interValDateTime = setInterval(() => {
					this.getPercentRange(new Date(this.fromDateTime), new Date(this.endDateTime), new Date());
				}, this.timeRefresh);
			}

			dateDifferenceInMinutes(fromDateTime, endDatetime) {
				const fromEndRange = (endDatetime - fromDateTime) / 60_000;

				return fromEndRange;
			}

			getPercentRange(fromDateTime, endDatetime, currentDateTime) {
				let percentValue = "0";

				const totalMinutes = this.dateDifferenceInMinutes(fromDateTime, endDatetime);
				const passMinutes = this.dateDifferenceInMinutes(fromDateTime, currentDateTime);

				if (passMinutes >= totalMinutes) {
					percentValue = "100";
					clearInterval(this.interValDateTime);
				} else {
					percentValue = (passMinutes / totalMinutes) * 100;
				}

				this.setAttribute("style", "--percent-range:" + percentValue + "%");
			}
		}
	);
}
